import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { useFormik, FormikProvider, FieldArray } from "formik";
// import * as Yup from "yup";
import {  Apitoken, Authtoken  } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const AddOrder = () => {
  const [customerNames, setcustomerNames] = useState([]);
  const [productLists, setproductLists] = useState([]);
  const [packagingTypesLists, setPackagingTypesLists] = useState([]);
  const [palletsTypesLists, setPalletsTypesLists] = useState([]);
  const [menu, setMenu] = useState(false);
  const [showTableHeadings, setShowTableHeadings] = useState(false);
  const [backendErrors, setBackendErrors] = useState([]);
  // const [backendSuccess, setBackendSuccess] = useState(null);
  const [shippingNames, setshippingNames] = useState([]);
  const [addressList, setAddressList] = useState([]);
  const [brokerList, setBrokerList] = useState([]);
  const [locationLoading, setLocationLoading] = useState([]);
  const [currencySymbol, setCurrencySymbol] = useState('€');
  const [statusOptions, setStatusOptions] = useState([]);
  const [permission, setPermission] = useState({});

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const [defaultDate, setDefaultDate] = useState(formatDate(new Date()));
    let season_id = localStorage.getItem("season_id");


  const formik = useFormik({
    initialValues: {
      season_id:season_id,
      customer: "",
      eta_date: defaultDate,
      eta_week: '',
      shipping_method: "",
      shipping_address: "",
      location: "",
      exportator_number:"",
      broker:"",
      remarks: "",
      price: "",
      order_status: "",
  
      contents: [],
    },
    onSubmit: (values, { setSubmitting }) => {
      axios
        .post("/orders/add", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          $("#form-submit").text("Add Order"); 
          delete backendErrors['error'];
        //  actions.setSubmitting(false);
        setSubmitting(false);
          if (response.data.code === 200) {
            //setBackendSuccess(response.data.message);
            toast.success(response.data.message);
           // actions.resetForm();
            setTimeout(() => {
              window.location.href = "/orders";
            }, 1000);
          }  else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }


        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  useEffect(() => {
        setPermission(FindModuleById(6)); 

          console.log(permission);


    axios
      .get("/helpers/orders-status", {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let orders_status12 = response.data.data.orders_status;
          let orders_status = orders_status12.map((ord, index) => ({
          label: ord.title,
          value: ord.id,
          key: `product-${index}`,
        }));
         setStatusOptions(orders_status);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });


    axios.get(`/helpers/loading-locations`, {headers: {Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken,},
    }).then((response) => {
      if (response.data.code === 200) {
        let locations = response.data.data.locations;
       
          let locationslist = locations.map((ord, index) => ({
          label: ord.title,
          value: ord.id,
          key: `product-${index}`,
        }));
        setLocationLoading(locationslist);
      } else {
        console.log("API response is not an array");
      }
    })
    .catch((error) => {
      console.log(error);
    });

    axios.post("/helpers/get-all-customers", {}, {headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
    .then((response) => {
     // let customers = response.data.data.customers;
      if (response.data.code === 200) {
        let shipping_methods = response.data.data.customers;
        let customerOptions = shipping_methods.map((customer, index) => ({
          label: customer.company_name,
          value: customer.id,
          key: `customer-${index}`,
        }));
        setcustomerNames(customerOptions);
      } else {
        console.log("API response is not an array");
      }
    })
    .catch((error) => {
      console.log(error);
    });
    axios .post( "/products/listing-category-type", {}, {  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, }
      ).then((response) => {
        if (response.data.code === 200) {
          let products = response.data.data.products;
          let productslisting = products.map((customer, index) => ({
            label: customer.productname ,
            value: customer.id,
            key: `address-${index}`,
          }));
          setproductLists(productslisting);
         
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });

    axios.get("/helper/order-packaging-types", {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }).then((response) => {
        if (response.data.code === 200) {
          let materials_payment_status = response.data.data.types;
          let productionlisting = materials_payment_status.map(
            (customer, index) => ({
              label: customer.title,
              value: customer.id,
              key: `typee-${index}`,
            })
          );
          setPackagingTypesLists(productionlisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
      
    axios.get("/helpers/pallettype", {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    }).then((response) => {
      if (response.data.code === 200) {
        let materials_payment_status =
          response.data.data.types;
        let productionlisting = materials_payment_status.map(
          (customer, index) => ({
            label: customer.title,
            value: customer.id,
            key: `typee-${index}`,
          })
        );
        setPalletsTypesLists(productionlisting);
      } else {
        console.log("API response is not an array");
      }
    })
    .catch((error) => {
      console.log(error);
    });
      axios .get("/helpers/shipping-methods", {  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
      .then((response) => {
        if (response.data.code === 200) {
          let shipping_methods = response.data.data.shipping_methods;
          let shipping_methodslist = shipping_methods.map((customer, index) => ({
            label: customer.title,
            value: customer.id,
            key: `address-${index}`,
          }));
          setshippingNames(shipping_methodslist);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
   
  }, []);
  const handleGetAddressByCustomer = (event) => {
    const customer_id = event.value;

    if (customer_id != "") {
      axios
        .post(`/addresses/listing/${customer_id}`, {}, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if (response.data.code === 200) {
            let customers = response.data.data.customers;
            let addresses = customers.map((customer, index) => ({
              label: customer.name,
              value: customer.id,
              key: `address-${index}`,
            }));

            setAddressList(addresses);
            setCurrencySymbol(response.data.data.customer_currency)
          }
        })
        .catch((error) => {
          console.log(error);
        });
        axios.get(`/customers/view/${customer_id}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }).then((response) => {
          if (response.data.code === 200) {
              let brokerss = response.data.data.user.brokers;
              
              let brklist = brokerss.map((brk, index) => ({
                label: brk.broker_name,
                value: brk.id,
                key: `brk-${index}`,
              }));
            setBrokerList(brklist);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };
  const handleKeyPressNumber = (event) => {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  };
 
  const exportatornumber = [
    { value: '9703', label: "9703" },
    { value: '106236', label: "106236" }
  ];

  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };
  
  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />  <ToastContainer />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Orders</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/orders">
                        Orders
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Add Orders
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  {permission && permission.add == 1 && (
                    <div className="card-body">
                      <h4 className="card-title">Add Order</h4>
                      <FormikProvider value={formik}>
                        <form onSubmit={formik.handleSubmit}>
                          <div className="row">
                            <div className="col-md-6">
                            <div className="form-group status">
                              <label>Customer</label>
                                <Select
                                  className="w-100"
                                  value={customerNames.find(option => option.value == formik.values.customer) || null} // Ensure correct format
                                  name="customer"
                                  onChange={(selectedOption) => {
                                    handleSelectChange("customer", selectedOption);
                                    handleGetAddressByCustomer(selectedOption);
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={customerNames}
                                  placeholder="Select"
                              
                               
                              />

                              <small>
                                {backendErrors.customer && (
                                  <span className="form-error mt-1">
                                    {backendErrors.customer}
                                  </span>
                                )}
                              </small>
                            </div>
                            <div className="form-group status">
                              <label>Production Location</label>
                              <Select
                               className="w-100"
                               value={locationLoading.find(option => option.value == formik.values.location) || null} // Ensure correct format
                               name="location"
                               onChange={(selectedOption) => {
                                 handleSelectChange("location", selectedOption);
                                // handleGetAddressByCustomer(selectedOption);
                               }}
                               onBlur={formik.handleBlur}
                               options={locationLoading}
                               placeholder="Select"
                           
                              />
                          
                              <small>
                                {backendErrors.location && (
                                  <span className="form-error mt-1">
                                    {backendErrors.location}
                                  </span>
                                )}
                              </small>
                            </div>
                          
                            
                            </div>
                            <div className="col-md-6">

                            <div className="form-group status">
                              <label>Shipping Address</label>
                            
                              <Select
                                className="w-100"
                                value={addressList.find(option => option.value == formik.values.shipping_address) || null} // Ensure correct format
                                name="shipping_address"
                                onChange={(selectedOption) => {
                                  handleSelectChange("shipping_address", selectedOption);
                                  // handleGetAddressByCustomer(selectedOption);
                                }}
                                onBlur={formik.handleBlur}
                                options={addressList}
                                placeholder="Select"

                              />
                              <small>
                                {backendErrors.shipping_address && (
                                    <span className="form-error mt-1">
                                      {backendErrors.shipping_address}
                                    </span>
                                  )}
                              </small>
                            </div>

                              <div className="form-group shipping_method status">
                              <label>Shipping Method</label>
                              <Select
                                className="w-100"
                                value={shippingNames.find(option => option.value == formik.values.shipping_method) || null} // Ensure correct format
                                name="shipping_method"
                                onChange={(selectedOption) => {
                                  handleSelectChange("shipping_method", selectedOption);
                                  // handleGetAddressByCustomer(selectedOption);
                                }}
                                onBlur={formik.handleBlur}
                                options={shippingNames}
                                placeholder="Select"

                              />
                              <small>
                                {backendErrors.shipping_method && (
                                  <span className="form-error mt-1">
                                    {backendErrors.shipping_method}
                                  </span>
                                )}
                              </small>
                            </div>
                        
                          
                            </div>
                          </div>

                          <div className="row">
                            
                              <div className="col-md-6">
                                <div className="form-group">
                                    <label>ETA Week</label> 
                                    <input
                                      type="text"
                                      onKeyPress={(event) => {
                                        // Allow only numbers (0-9)
                                        if (!/^[0-9]$/.test(event.key)) {
                                          event.preventDefault();
                                        }
                                      }}
                                      className="form-input form-control"
                                      name="eta_week"
                                      value={formik.values.eta_week}
                                      onChange={(e) => {
                                        formik.handleChange(e);
                                        customHandleInput(e);
                                        setDefaultDate(e.target.value);
                                      }}
                                      onBlur={formik.handleBlur}
                                    
                                    />
                                    <small>
                                      {backendErrors.eta_week && (
                                          <span className="form-error mt-1">
                                            {backendErrors.eta_week}
                                          </span>
                                        )}
                                    </small>
                                  </div>
                                  

                                  <div className="form-group status">
                                      <label>Order Status</label>
                                      <Select
                                       className="w-100"
                                       value={statusOptions.find(option => option.value == formik.values.order_status) || null} // Ensure correct format
                                       name="order_status"
                                       onChange={(selectedOption) => {
                                         handleSelectChange("order_status", selectedOption);
                                         // handleGetAddressByCustomer(selectedOption);
                                       }}
                                       onBlur={formik.handleBlur}
                                       options={statusOptions}
                                       placeholder="Select"
                                      />
                                      <small>
                                        {backendErrors.order_status && (
                                          <span className="form-error mt-1">
                                            {backendErrors.order_status}
                                          </span>
                                        )}
                                      </small>
                                    </div>
                                  
                        

                                </div>
                            <div className="col-md-6">
                            <div className="form-group status">
                              <label>Broker</label>
                            
                              <Select
                                className="w-100"
                                value={brokerList.find(option => option.value == formik.values.broker) || null} // Ensure correct format
                                name="broker"
                                onChange={(selectedOption) => {
                                  handleSelectChange("broker", selectedOption);
                                  // handleGetAddressByCustomer(selectedOption);
                                }}
                                onBlur={formik.handleBlur}
                                options={brokerList}
                                placeholder="Select"
                              
                              />
                              <small>
                                {backendErrors.broker && (
                                    <span className="form-error mt-1">
                                      {backendErrors.broker}
                                    </span>
                                  )}
                              </small>
                            </div>
                            </div>
                            <div className="col-md-6">
                                  <div className="form-group">
                                      <label>Exportator Number</label>
                                    
                                      <Select
                                        className="w-100"
                                        value={exportatornumber.find(option => option.value == formik.values.exportator_number) || null} // Ensure correct format
                                        name="exportator_number"
                                        onChange={(selectedOption) => {
                                          handleSelectChange("exportator_number", selectedOption);
                                          // handleGetAddressByCustomer(selectedOption);
                                        }}
                                        onBlur={formik.handleBlur}
                                        options={exportatornumber}
                                        placeholder="Select"
                                      />
                                      <small>
                                        {backendErrors.exportator_number && (
                                            <span className="form-error mt-1">
                                              {backendErrors.exportator_number}
                                            </span>
                                          )}
                                      </small>
                                    </div>
                                  </div>


                            <div className="col-md-12">
                            

                            

                            <div className="form-group">
                                <label>Remarks</label>
                                <textarea
                            
                                  className="form-input form-control"
                                  name="remarks"
                                  value={formik.values.remarks}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                ></textarea>
                                <small>
                                  {backendErrors.remarks && (
                                      <span className="form-error mt-1">
                                        {backendErrors.remarks}
                                      </span>
                                    )}
                                </small>
                              </div>
                              </div>
                              </div>

                          <div className="row">
                            <div className="col-md-6">
                              <h4 className="card-title">
                                <br />
                                Items
                              </h4>
                            </div>
                          </div>
                          <FieldArray
                            name="contents"
                            render={(arrayHelpers) => (
                              <div style={{overflow:"auto12"}}>
                                <button
                                  className="btn btn-primary mb-3"
                                  type="button"
                                  onClick={() => {
                                    let appendArr =arrayHelpers.form.values.contents[0];
                                    let initialArr ={
                                      pallet_number: "",
                                      product: "",
                                      calibre: "",
                                      packaging_type: "",
                                      pallet_type: 3,
                                      price: "",
                                      // number_of_boxes: "",
                                    }
                                    appendArr = (appendArr)?appendArr:initialArr;
                                    arrayHelpers.push(appendArr);
                                    setShowTableHeadings(true);
                                  
                                  }}
                                >
                                  +
                                </button>

                                <table className="table table-padding">
                                  {showTableHeadings && (
                                    <thead>
                                      <tr>
                                        <th style={{width:"10%"}}>Number <br/> of Pallets</th>
                                        <th style={{width:"25%"}} >Product</th>
                                        <th style={{width:"10%"}}> Caliber</th>
                                        <th style={{width:"20%"}} >Packaging<br/> Type</th>
                                        <th  style={{width:"15%"}}>Pallet<br/> Type</th>
                                        <th style={{width:"15%"}}>Price</th>
                                        {/* <th style={{width:"15%"}} >Boxes</th> */}
                                        <th  style={{width:"5%"}}></th>
                                    
                                      </tr>
                                    </thead>
                                  )}
                                  <tbody>
                                    {formik.values.contents.map(
                                      (friend, index) => (
                                        <tr key={index}>
                                          <td style={{width:"10%"}}>
                                            <div className="form-group status">
                                              <input
                                                type="text"  onKeyPress={handleKeyPressNumber}
                                                className="form-input form-control"
                                                name={`contents[${index}].pallet_number`}
                                                value={
                                                  formik.values.contents[index]
                                                    .pallet_number
                                                }
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td  style={{width:"25%"}}>
                                            <div className="form-group status">
                                              <Select
                                               name={`contents[${index}].product`}
                                               options={productLists}
                                               value={productLists.find(option => option.value == formik.values.contents[index].product) || null} // Ensure correct format
                                               onChange={(selectedOption) => {
                                                 formik.setFieldValue(`contents[${index}].product`, selectedOption.value); // ✅ Store only value in Formik
                                                 customHandleInput({
                                                   target: {
                                                     name: `contents[${index}].product`,
                                                     value: selectedOption.value, // ✅ Ensure only value is passed
                                                   },
                                                 });
                                               }}
                                               onBlur={formik.handleBlur}
                                               placeholder="Select"
                                               className="w-100"
                                              />
                                            </div>
                                          </td>
                                          <td style={{width:"10%"}}>
                                            <div className="form-group status">
                                              <input
                                              min="0"
                                                type="text"  onKeyPress={handleKeyPressNumber}
                                                className="form-input form-control"
                                                name={`contents[${index}].calibre`}
                                                value={
                                                  formik.values.contents[index]
                                                    .calibre
                                                }
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td>
                                          <td style={{width:"20%"}}>
                                            <div className="form-group status">
                                              <Select
                                               name={`contents[${index}].packaging_type`}
                                               options={packagingTypesLists}
                                               value={packagingTypesLists.find(option => option.value == formik.values.contents[index].packaging_type) || null} // Ensure correct format
                                               onChange={(selectedOption) => {
                                                 formik.setFieldValue(`contents[${index}].packaging_type`, selectedOption.value); // ✅ Store only value in Formik
                                                 customHandleInput({
                                                   target: {
                                                     name: `contents[${index}].packaging_type`,
                                                     value: selectedOption.value, // ✅ Ensure only value is passed
                                                   },
                                                 });
                                               }}
                                               onBlur={formik.handleBlur}
                                               placeholder="Select"
                                               className="w-100"

                                               
                                              />
                                            </div>
                                          </td>
                                          <td style={{width:"15%"}}>
                                            <div className="form-group status">
                                              <Select
                                                 name={`contents[${index}].pallet_type`}
                                                 options={palletsTypesLists}
                                                 value={palletsTypesLists.find(option => option.value == formik.values.contents[index].pallet_type) || null} // Ensure correct format
                                                 onChange={(selectedOption) => {
                                                   formik.setFieldValue(`contents[${index}].pallet_type`, selectedOption.value); // ✅ Store only value in Formik
                                                   customHandleInput({
                                                     target: {
                                                       name: `contents[${index}].pallet_type`,
                                                       value: selectedOption.value, // ✅ Ensure only value is passed
                                                     },
                                                   });
                                                 }}
                                                 onBlur={formik.handleBlur}
                                                 placeholder="Select"
                                                 className="w-100"

                                              />
                                            </div>
                                          </td>
                                      
                                          <td style={{width:"15%"}}>
                                            <div className="form-group">
                                            
                                              <div className="input-group" style={{width:"max-content"}}>
                                                  <input type="text"  
                                                  name={`contents[${index}].price`}
                                                  onKeyPress={(event) => {
                                                    // Prevent non-numeric input for keypress
                                                    if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                                      event.preventDefault();
                                                    }
                                                  }}
                                                  value={
                                                    formik.values.contents[index]
                                                      .price
                                                  }
                                                  // onChange={
                                                  //   formik.handleChange
                                                  //   handleInputChange
                                                  // }
                                                  onChange={(e) => {
                                                    formik.handleChange(e);
                                                    // handleInputPrice(e);
                                                  }}
                                                  onBlur={formik.handleBlur}
                                                  className="form-control" placeholder="Price" aria-label="Price" aria-describedby="basic-addon2" />
                                                  <div className="input-group-append">
                                                      <span className="input-group-text" id="basic-addon2">{currencySymbol}</span>
                                                  </div>
                                              </div>
                                            </div>
                                          </td>
                                          {/* <td style={{width:"15%"}}>
                                            <div className="form-group">
                                              <input
                                                type="text"  onKeyPress={handleKeyPressNumber}
                                                placeholder="Enter Boxes"
                                                className="form-input form-control"
                                                name={`contents[${index}].number_of_boxes`}
                                                value={
                                                  formik.values.contents[index]
                                                    .number_of_boxes
                                                }
                                                onChange={formik.handleChange}
                                              />
                                            </div>
                                          </td> */}
                                        
                                          <td style={{width:"5%"}}>
                                            <div className="form-group">
                                              <button
                                                className="btn btn-danger"
                                                // style={{ marginTop: 30 }}
                                                type="button"
                                                onClick={() =>
                                                  arrayHelpers.remove(index)
                                                }
                                              >
                                                -
                                              </button>
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          />

                          <div className="text-end mt-4">
                            <button className="btn btn-primary" type="submit" id="form-submit" disabled={formik.isSubmitting}>
                                Add Order
                            </button>
                          </div>
                        </form>
                      </FormikProvider>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AddOrder;
